angular.module('elfium').directive('dashboardSumPanel', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {
        	type: '@',
        	header: '@',
        	currentSum: '=',
        	expectedSum: '='
        },
        controller: 'dashboardSumPanelController',
        templateUrl: elfiumUrlService.getTemplateUrl('dashboard', 'dashboardSumPanel')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardSumPanel.ts